import { render, staticRenderFns } from "./SegmentedPickerTabs.vue?vue&type=template&id=3ca6a6ca&scoped=true"
import script from "./SegmentedPickerTabs.vue?vue&type=script&lang=js"
export * from "./SegmentedPickerTabs.vue?vue&type=script&lang=js"
import style0 from "./SegmentedPickerTabs.vue?vue&type=style&index=0&id=3ca6a6ca&prod&scoped=true&lang=css"
import style1 from "./SegmentedPickerTabs.vue?vue&type=style&index=1&id=3ca6a6ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6a6ca",
  null
  
)

export default component.exports